/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsNotificationEmailType from '@jira/spa-apps__project-settings-notification-email/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsNotificationEmail: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsNotificationEmailType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-notification-email", jiraSpaEntry: "async-project-settings-notification-email" */ '@jira/spa-apps__project-settings-notification-email/src/ExportedDefault.tsx'
		),
	),
);

const AsyncProjectSettingsNotificationEmail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsNotificationEmail}
		pageId="project-settings-email-notifications"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsNotificationEmail;
